// @greenlight-spec: 19-design-system.md

/**
 * Deterministic hue derivation and monogram utilities for consistent per-seed
 * color assignment across avatars and app tiles.
 */

/**
 * Returns a deterministic hue in [0, 359] derived from the given seed string.
 * The same seed always produces the same hue; unrelated seeds spread across
 * the full circle due to the polynomial rolling hash.
 */
export function hueFor(seed: string): number {
  let h = 0;
  for (const c of seed) h = (h * 31 + c.charCodeAt(0)) % 360;
  return h;
}

/**
 * Returns 1–2 uppercase initials from a display name, never empty.
 * Single-word names yield one initial; multi-word names yield first + second word initials.
 * Falls back to the first character of the raw string, then '?' as a last resort.
 */
export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const first = parts[0]?.[0] ?? '';
  const second = parts[1]?.[0] ?? '';
  const out = (first + second).toUpperCase();
  return out || (name.trim()[0]?.toUpperCase() ?? '?');
}
